import { writable } from 'svelte/store'
import type { Writable } from 'svelte/store'
import type { DriverEnquiryResult,  DriverTopupPaymentGatewayResult,  DriverTopupRequest, DriverTopupResult } from '@/components/appDriver/types'

export const enquiryResult: Writable<DriverEnquiryResult | null> = writable(null)

export const topupRequest: Writable<DriverTopupRequest> = writable({
  channel: '',
  amount: 0,
  lastAppointmentBookingId: null,
})

export const topupPaymentGatewayResult: Writable<DriverTopupPaymentGatewayResult | null> = writable(null)

export const topupResult: Writable<DriverTopupResult | null> = writable(null)

export const currentPage: Writable<string> = writable('home')
